import $ from 'jquery';

class Common {

    constructor() {

        this.scroll = {};
        this.screen = {};
        this.$window = $(window);
        this.$document = $(document);
        this.$body = $('body');
        this.userAgent = {
            // firefox
            firefox: !!navigator.userAgent.match(/firefox/i),
            // opera
            opera: !!window.opera || /opera|opr/i.test(navigator.userAgent),
            // ie >= 10
            ie: document.body.style.msTouchAction !== undefined,
            // chrome > 14 (09/2011)
            chrome: !!window.chrome && !!window.chrome.webstore,
            // safari
            safari: /constructor/i.test(window.HTMLElement)
        };

        this.getInfo = this.getInfo.bind(this);
        this.getScrollInfo = this.getScrollInfo.bind(this);
        this.init = this.init.bind(this);
        this.$window.on('resize', this.getInfo);
        this.$window.on('scroll', this.getScrollInfo);

        // var FastClick = require('fastclick');
        // FastClick.attach(document.body);

        this.init();

    }

    init(){

        this.getInfo();
        this.getScrollInfo();

    }

    // toggleScrollCss() {
    //
    //     if (!this.$body.data('is-block-scroll')) {
    //
    //         this.blockScrollCss();
    //
    //     } else {
    //
    //         this.enableScrollCss();
    //
    //     }
    //
    // }

    // blockScrollCss() {
    //
    //     var _this = this,
    //         offsetTop = -_this.$window.scrollTop();
    //
    //     _this.$body.attr('data-scroll-top', -offsetTop);
    //
    //     overflow = 'visible';
    //
    //     if (_this.$body.height() > _this.screen.height) {
    //
    //         overflow = 'scroll';
    //
    //     }
    //
    //     _this.$body.data('is-block-scroll', true);
    //
    //     _this.$body.css({
    //         position: 'fixed',
    //         top: offsetTop,
    //         left: 0,
    //         overflowY: overflow
    //     });
    //
    // }

    // enableScrollCss() {
    //
    //     var _this = this,
    //         scrollTop = _.parseInt(_this.$body.attr('data-scroll-top'));
    //
    //     _this.$body.css({
    //         position: 'static',
    //         top: 'auto',
    //         left: 'auto',
    //         overflowY: 'visible'
    //     });
    //
    //     _this.$body.data('is-block-scroll', false);
    //
    //     _this.$window.scrollTop(scrollTop);
    //
    // }

    getInfo() {

        this.screen.documentHeight = $(document).height();
        this.screen.height = window.innerHeight || this.$window.height();
        this.screen.width = window.innerWidth || this.$window.width()
        this.screen.ratio = this.screen.height / this.screen.width;

    }

    getScrollInfo(){

        this.scroll.current = this.$window.scrollTop();
        this.scroll.max = this.screen.documentHeight - this.screen.height;

    }

    isElementEntirelyInViewport(el) {

        el = (el instanceof jQuery) ? el[0] : el;

        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= this.screen.height &&
            rect.right <= this.screen.width
        );

    }

}

export default new Common();


// WEBPACK FOOTER //
// ./js/base/common.js